import { BasicClient } from '@/utils/httpClient'

export default class Workflow {
  client: BasicClient

  constructor() {
    this.client = new BasicClient()
  }

  getApprovalOrdersList() {
    return this.client.exec(`/team-approve?state=true`, 'GET')
  }
  getDocumentList() {
    return this.client.exec('/v2/admin-mod/workflow/document', 'GET')
  }
  createWorkflow(params = {}) {
    return this.client.exec('/v2/admin-mod/workflow', 'POST', params)
  }

  getWorkflowList() {
    return this.client.exec('/v2/admin-mod/workflow', 'GET')
  }

  disableWorkflow(id) {
    return this.client.exec(`/v2/admin-mod/workflow/${id}`, 'PATCH', { status: 0 })
  }
}
